<template>
  <div class="sort-filter">
    <div
      v-for="option in options"
      class="sort-filter-item"
      :class="{
        'sort-filter-item--active': hasSort(option.value) || option.value === sort
      }"
      @click="onItemClick(option)"
    >
      {{ option.label }}
      <div
        class="sort-filter-item__right"
        v-if="option.sortable"
      >
        <Icon
          class="sort-filter-item__icon sort-filter-item__icon--up"
          :class="{
            'sort-filter-item__icon--active': sort?.[option.value] === 'asc'
          }"
          name="triangle-right-s"
        />
        <Icon
          class="sort-filter-item__icon sort-filter-item__icon--down"
          :class="{
            'sort-filter-item__icon--active': sort?.[option.value] === 'desc'
          }"
          name="triangle-right-s"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'

const options = [
  {
    value: null,
    label: 'Best Match'
  },
  {
    value: 'monthSold',
    label: 'Bestselling'
  },
  {
    value: 'price',
    label: 'Price',
    sortable: true
  }
]

const sort = defineModel('sort', { type: Object, default: () => ({}) })

const hasSort = (key) => {
  if (sort.value == null) return false
  return Reflect.has(sort.value, key)
}

const onItemClick = (option) => {
  if (option.value == null) sort.value = null
  else {
    const currentValue = sort.value?.[option.value]
    sort.value = { [option.value]: option.sortable ? (currentValue === 'asc' ? 'desc' : 'asc') : 'desc' }
  }
}
</script>

<style lang="less">
.sort-filter {
  display: flex;
  align-items: center;
  gap: 8px;

  &-item {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 24px;
    padding: 0 12px;
    border-radius: 4px;
    border: 1px solid #ebf1f5;
    background: #f5f5f5;
    font-family: mon-500;
    font-size: 12px;
    color: #232323;
    cursor: pointer;

    &:hover {
      border: 1px solid #232323;
    }

    &--active {
      color: #ffffff;
      background: #232323;
      border-color: #232323;
    }

    &__right {
      display: flex;
      flex-direction: column;
    }

    &--active &__icon {
      opacity: 0.5;
    }

    &--active &__icon--active {
      opacity: 1;
      color: #ffffff;
    }

    &__icon {
      font-size: 8px;
      color: #b2b7c2;

      &--up {
        transform: rotate(-90deg);
      }

      &--down {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
